export default {
  全部交易产品: "ผลิตภัณฑ์เทรดทั้งหมด",
};
